import React, { CSSProperties, ReactNode } from 'react'
import styles from './Button.module.css'

function BlueBtn({
	children,
	title,
	onclick,
	dsbl,
	style
}: {
	children: ReactNode
	title: string
	onclick: () => void
	dsbl?: boolean
	style?: CSSProperties
}) {
	return (
		<>
			<div className={styles.notes}>
				<button disabled={dsbl} className={styles.notes_btn} onClick={onclick} style={{ opacity: dsbl ? '.6' : '1', ...style }}>
					{children}
					{title}
				</button>
			</div>
		</>
	)
}

export default BlueBtn
